<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  mounted: async function () {
    this.$store.dispatch('initSessionKey')
  }
  // load lookup data & data for data stories...
}
</script>

<style>
  body, html {
    overflow-x: hidden;
    overflow-y: auto;
  }

  /* this is a fix for a glitch introduced with vuetify 1.3.7. */
  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue